import { Dialog, DialogPanel } from '@headlessui/react';

import CautionIcon from '~/shared/assets/icons/caution.svg';
import Typography from '~/shared/components/Typography';
import Button from '~/shared/components/ButtonsV2';

interface ToggleRuleModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isTurningOn: boolean;
  isPending: boolean;
}

export default function ToggleRuleModal({
  isOpen,
  onClose,
  onConfirm,
  isPending,
}: ToggleRuleModalProps) {
  const title = 'Are you sure you want to turn off this rule?';

  const message =
    'New volumes that match this rule will not be autoscaled. Volumes already autoscaled by this rule will continue autoscaling.';

  const handleClose = () => {
    if (!isPending) {
      onClose();
    }
  };

  return (
    <Dialog
      open={isOpen}
      as="div"
      className="relative z-[99] focus:outline-none auto-scale-rule-dialog"
      onClose={handleClose}
    >
      <div
        className="fixed inset-0 p-4 w-screen overflow-y-auto bg-[#00000059] backdrop-blur-[6px] auto-scale-rule-dialog-backdrop"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-center min-h-screen p-4">
          <DialogPanel
            transition
            className="w-full max-w-[689px] rounded-xl bg-white p-6 backdrop-blur-2xl duration-300 ease-out data-closed:transform-[scale(95%)] data-closed:opacity-0"
          >
            <div className="flex flex-col w-full items-center">
              <CautionIcon className="size-10 text-red" />
              <Typography variant="H3-med" fontWeight={600} className="mt-6 font-family-outfit">
                {title}
              </Typography>
              <Typography variant="p3-reg" className="mt-2 max-w-[536px] text-center">
                {message}
              </Typography>

              <div className="flex gap-3 mt-6 pt-6">
                <Button
                  variant="secondary"
                  className="px-7.5 py-3"
                  onClick={handleClose}
                  disabled={isPending}
                >
                  <Typography variant="p3" color="text-primary-900">
                    No
                  </Typography>
                </Button>
                <Button className="px-7.5 py-3" onClick={onConfirm} disabled={isPending}>
                  {isPending ? 'Yes' : 'Yes'}
                </Button>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
